module.exports = __webpack_public_path__ + "img/medical_team_white.25ad65dd.svg";